import { render } from "./WebDAV.vue?vue&type=template&id=bdc413d6"
import script from "./WebDAV.vue?vue&type=script&lang=js"
export * from "./WebDAV.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__